<template>
  <div class="expose-products-preview" v-if="displayList.length > 0">
    <div class="header">
      <span class="title">{{ title }}</span>
    </div>
    <div class="product-list">
      <div class="product-item" v-for="(item, index) in displayList" :key="index">
        <div class="img-box">
          <img :src="item.logo" class="product-img" />
        </div>
        <div class="info-box">
          <div class="name">{{ item.title }}</div>
          <div class="price-cart">
            <div class="price"><span class="unit">¥</span>{{ item.price }}</div>
            <div class="cart-btn">
              <img class="shoppingCartIcon" :src="$globalCdn + '/images/shoppingCartIcon.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'exposeProductsPreview',
  props: {
    title: {
      type: String,
      default: '店长推荐'
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    displayList() {
      return this.productList.length > 0 ? this.productList : [];
    }
  },
  methods: {}
}
</script>

<style lang='scss' scoped>
.expose-products-preview {
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 8px 0px;
  box-sizing: border-box;

  .header {
    margin-bottom: 12px;

    .title {
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      line-height: 12px;
    }
  }

  .product-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 8px;
  }

  .product-item {
    width: calc(50% - 4px);
    background: #fff;
    border-radius: 8px;
    border: 1px solid #f5f5f5;
    overflow: hidden;

    .img-box {
      width: 100%;
      aspect-ratio: 1;
      background: linear-gradient(180deg, #E6EFFF 0%, #F5F7FA 100%);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .product-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info-box {
      padding: 8px;

      .name {
        font-weight: 400;
        font-size: 11px;
        color: #333333;
        line-height: 18px;
        height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 5px;
      }

      .price-cart {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .price {
          font-weight: 500;
          font-size: 11px;
          color: #FE2A54;

          .unit {
            font-weight: 500;
            font-size: 8px;
            color: #FE2A54;
            margin-right: 2px;
          }
        }

        .cart-btn {
          width: 16px;
          height: 16px;

          .shoppingCartIcon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}
</style>